import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { TablePagination, Dialog, Checkbox } from '@material-ui/core';
import MaterialTable from 'material-table';
import ReactPlayer from 'react-player';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { updateModalContent, toggleModal } from '../../actions/modal';
import { getAds, deleteAd, bulkUpdateAds } from '../../actions/admin/advertisementAction';
import Constants from '../../common/constants';
import { IsEmpty } from '../../common/checks';
import { ConvertDateToSGTime, ElipsisString } from '../../common/util';
import ProgressiveImage from '../common/ProgressiveImage';
import convert from '../../common/convert';

const pageOptions = [100];
class AdsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ads:        [],
      totalCount: 0,
      redirUrl:   null,

      configuration: {
        pageNo:   0,
        pageSize: pageOptions[0],
      },

      setVideo:  '',
      showVideo: false,
    };
  }

  componentDidMount() {
    this.fetchAds();
  }

  fetchAds = async () => {
    try {
      const data = await this.props.getAds(this.state.configuration);
      if (data.totalCount > 0) {
        this.setState({
          ads:        _.sortBy(data.rows, ['displayOrder'], ['asc']),
          totalCount: data.totalCount,
        });
      }
    } catch (err) {
      toast.error(err.message);
    }
  }

  handleRedirect = (url) => {
    this.setState({ redirUrl: url });
  }

  handleBulkUpdate = async (id) => {
    const ads = await this.props.getAds(this.state.configuration);
    if (ads.totalCount > 0) {
      const data = ads.rows.filter((ad) => ad.id !== id);
      const res = await this.props.bulkUpdateAds(data);
      if (res) {
        this.setState({ ads: res }, () => this.props.callback());
      }
    } else {
      this.setState({ ads: ads.rows }, () => this.props.callback());
    }
  }

  handleDelete = (id) => {
    this.props.updateModalContent({
      title:        'Are you sure?',
      content:      'All data related to this advertisement will be deleted!',
      actionButton: {
        actionText: 'Yes, Delete',
        actionType: 'danger',
        action:     async () => {
          await this.props.deleteAd(id)
            .then((result) => {
              if (result === Constants.Success) {
              toast.success('Advertisement deleted.');
              this.handleBulkUpdate(id);
              }
            })
            .catch((err) => {
            toast.error(err.message);
            });
        },
      },
      cancelText:       'Cancel',
      closeAfterAction: true,
    });
    this.props.toggleModal();
  }

  handleChangePage = (pageNo) => {
    this.setState({ configuration: { ...this.state.configuration, pageNo } }, () => this.fetchAds());
  }

  handleChangeRowsPerPage = (pageSize) => {
    this.setState({ configuration: { pageNo: 0, pageSize } }, () => this.fetchAds());
  };

  render() {
    if (this.state.redirUrl) { return <Redirect to={this.state.redirUrl} />; }
    return (
      <>
        <MaterialTable
          title=""
          columns={[
            { title: 'Display Order', field: 'displayOrder', width: '30px' },
            { title:  'Preview', field:  'image', render: (ad) => {
              if (!IsEmpty(ad.video)) {
                return (
                  <div onClick={() => this.setState({ showVideo: true, setVideo: ad.video })}>
                    <ReactPlayer
                      url={ad.video}
                      muted
                      playing
                      style={{
                        borderRadius: '5px',
                        border:       '1px solid #CCC',
                        minWidth:     '50px',
                        maxWidth:     '50px',
                        height:       '50px',
                        maxHeight:    '50px',
                        cursor:       'pointer',
                      }}
                    />
                  </div>
                );
              } else {
                return (
                  <>
                    <ProgressiveImage
                      image={convert.imageResizeUrl(ad.image, 50, 50)}
                      width={50}
                      height={50}
                      style={{
                        objectFit:    'cover',
                        borderRadius: 5,
                        border:       '1px solid #CCC',
                      }}
                    />
                  </>
                );
              }
            } },
            { title: 'Id', field: 'id' },
            { title:  'Title', field:  'title', render: (ad) => (
              <Link to={`/admin/advertisement/${ad.id}`}>
                {ad.title}
              </Link>
            ) },
            { title: 'Brand', field: 'brand' },
            { title: 'Type', field: 'type' },
            { title: 'Takeover', field: 'isTakeOver', render: (ad) => (ad.isScreenTakeOver ? <Checkbox checked /> : null) },
            { title: 'Page Id', field: 'pageId' },
            { title: 'Post Id', field: 'postId' },
            { title: 'Url', field: 'url', width: '10%', render: (ad) => ElipsisString(ad.url, 20) },
            { title:  'Date From', field:  'dateFrom', render: (ad) => {
              const dateToSGTime = ConvertDateToSGTime(new Date(ad.dateFrom));
              return !IsEmpty(ad.dateFrom) ? `${dateToSGTime.getDate()} ${dateToSGTime.toLocaleString('en-SG', { month: 'long' })} ${dateToSGTime.getFullYear()}` : '--';
            } },
            { title:  'Date Till', field:  'dateTill', render: (ad) => {
              const dateToSGTime = ConvertDateToSGTime(new Date(ad.dateTill));
              return !IsEmpty(ad.dateTill) ? `${dateToSGTime.getDate()} ${dateToSGTime.toLocaleString('en-SG', { month: 'long' })} ${dateToSGTime.getFullYear()}` : '--';
            } },
            { title: 'Start Time', field: 'dailyStartTime' },
            { title: 'End Time', field: 'dailyEndTime' },
          ]}
          data={this.state.ads}
          actions={[
            {
              icon:    'edit',
              tooltip: 'View/Edit Ad',
              onClick: (event, ad) => {
              this.handleRedirect(`/admin/advertisement/${ad.id}`);
              },
            },
            {
              icon:    'delete',
              tooltip: 'Delete Ad',
              onClick: (event, ad) => {
              this.handleDelete(ad.id);
              },
            },
          ]}
          options={{
            actionsColumnIndex:  -1,
            search:              true,
            sorting:             false,
            paging:              true,
            emptyRowsWhenPaging: false,
            pageSize:            pageOptions.slice(-1)[0],
          }}
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                page={
                  this.state.configuration.pageNo
                }
                onChangePage={(e, page) => {
                this.handleChangePage(page);
                }}
                onChangeRowsPerPage={(e) => {
                this.handleChangeRowsPerPage(e.target.value);
                }}
                rowsPerPageOptions={pageOptions}
                rowsPerPage={this.state.configuration.pageSize}
                count={this.state.totalCount}
              />
            ),
          }}
        />
        <Dialog
          id="videoDialog"
          fullWidth
          maxWidth="sm"
          open={this.state.showVideo}
          onClose={() => this.setState({ showVideo: false, setVideo: '' })}
        >
          <ReactPlayer url={this.state.setVideo} playing loop controls />
        </Dialog>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getAds:             (data) => dispatch(getAds(data)),
  deleteAd:           (id) => dispatch(deleteAd(id)),
  bulkUpdateAds:      (ads) => dispatch(bulkUpdateAds(ads)),
  toggleModal:        () => dispatch(toggleModal()),
  updateModalContent: (data) => dispatch(updateModalContent(data)),
});

export default connect(null, mapDispatchToProps)(AdsTable);
